import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import FormAddEditBrands from '../../components/brands/FormAddEditBrands';

const CreateBrand = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditBrands />
        </WrapperSection>
    );
};

export default CreateBrand;
